import { getWithRedirect } from 'utils/axios'

import { Source } from 'types/GlobalSource'

const homepal_mdm_api =
  process.env.REACT_APP_HOMEPAL_MDM_API_DEV || 'http://localhost:3990/'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? homepal_mdm_api
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/connections/sources`

export async function getAll(params = '') {
  const url = `${URL}${params}`

  return getWithRedirect<Source[]>(url)
}

export async function getOne(id: string) {
  return getWithRedirect<Source>(`${URL}/${id}`)
}
